const theme = {
    colors: {
        // Dark backgrounds (like your homepage images)
        bg: {
            primary: '#0f172a',      // darkest slate
            secondary: '#1e293b',    // dark slate
            tertiary: '#0f172a',     // navy
            light: '#1e293b',        // slightly lighter
        },
        // Cyan/Blue accents (like your homepage images)
        accent: {
            cyan: '#06b6d4',         // bright cyan
            blue: '#0284c7',         // bright blue
            darkBlue: '#1e40af',     // darker blue
        },
        // Supporting colors
        text: {
            primary: '#ffffff',      // white
            secondary: '#e2e8f0',    // light gray
            muted: '#94a3b8',        // muted gray
        },
        status: {
            success: '#10b981',
            warning: '#f59e0b',
            danger: '#ef4444',
            info: '#3b82f6',
        }
    }
};

export default theme;